







































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
    Module
---------------------------------------- */

import anime from 'animejs';

/* ----------------------------------------
     Helpers
 ---------------------------------------- */

import * as dom from '@util/dom';

/* ----------------------------------------
    Transitions Position
---------------------------------------- */

const setPos = (el, pos) => {
    anime({
        targets: el,
        translateX: pos.x,
        translateY: pos.y,
        duration: 250,
        easing: 'easeOutQuad'
    });
};

const restorePos = el => {
    anime({
        targets: el,
        translateX: '-50%',
        translateY: '-50%',
        duration: 250,
        easing: 'easeOutQuad'
    });
};

/* ----------------------------------------
    Transitions Scale
---------------------------------------- */

const scaleIn = el => {
    anime({
        targets: el,
        scale: [1, 1.15],
        duration: 450,
        easing: 'easeOutQuad'
    });
};

const scaleOut = el => {
    anime({
        targets: el,
        scale: [1.15, 1],
        duration: 400,
        easing: 'easeOutBack'
    });
};

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    props: {
        content: Object
    },

    computed: {
        disciplines() {
            return this.content.disciplines.join(', ')
        }
    },

    methods: {
        enter: function(e) {
            scaleIn(this.$refs.scale);
            this.$refs.thumb.addEventListener('mousemove', this.move);
        },

        leave: function(e) {
            scaleOut(this.$refs.scale);
            this.$refs.thumb.removeEventListener('mousemove', this.move);
            // restorePos(this.$refs.image);
        },

        move: function(e) {
            const bounds = this.$refs.image.getBoundingClientRect();

            const width = bounds.width;
            const height = bounds.height;

            const left = bounds.left;
            const top = bounds.top;

            const centerX = left + width / 2;
            const centerY = top + height / 2;

            const posX = (centerX - e.screenX) * -1;
            const posY = (centerY - e.screenY) * -1;

            const percentageX = (posX / (width * 0.5)) * 1.5;
            const percentageY = (posY / (height * 0.5)) * 1.5;

            // dom.style(this.$refs.image, {
            //     transform: `translateX(${ dom.unit(percentageX - 50, '%') }) translateY(${ dom.unit(percentageY - 50, '%') })`
            // });
        }
    },

    mounted() {
        this.$refs.thumb.addEventListener('mouseenter', this.enter, false);
        this.$refs.thumb.addEventListener('mouseleave', this.leave, false);
    },

    beforeDestroy() {
        this.$refs.thumb.removeEventListener('mouseenter', this.enter, false);
        this.$refs.thumb.removeEventListener('mouseleave', this.leave, false);
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class CaseCard extends Vue {}

